import { Navigate } from 'react-router-dom'

/**
 * /register — superseded by the /signup wizard (2026-08 redesign). The route
 * survives as a redirect because it's linked from old emails and bookmarks.
 */
export function Register() {
  return <Navigate to="/signup" replace />
}
